import { styled } from '@nykaa/ui-components';

export const BackIcon = styled.div`
  width: 26px;
  height: 26px;
  display: inline-block;
  margin-right: ${({ theme }) => theme.spacing.spacing80};
  background: ${({ theme }) => theme.colors.surface20};
`;
export const SearchPlaceHolder = styled.div`
  width: 126px;
  height: 26px;
  display: inline-block;
  background: ${({ theme }) => theme.colors.surface20};
`;

export const Separator = styled.p`
  display: block;
  margin: 0;
  height: 1px;
  background: ${({ theme }) => theme.colors.textOutline};
`;

export const Container = styled.section`
  background: ${({ theme }) => theme.colors.surface};
`;

export const Input = styled.div`
  display: flex;
  align-items: center;
  padding: ${({ theme }) => theme.spacing.spacing40};
  background-color: ${({ theme }) => theme.colors.surface10};
  border-radius: ${({ theme }) => theme.borders.radius10};
  height: 40px;
  margin: ${({ theme }) => theme.spacing.spacing40};
  position: relative;
`;
